import styled from '@emotion/styled';

import * as c from '@identity/constants';

export const Container = styled.div`
  max-width: 750px;
  margin: 0 auto;
  padding: 40px 0;
  ${c.TABLET} {
    padding: 25px;
  }
`;

export const Wrapper = styled.figure`
  max-height: 500px;
  position: relative;
  padding-top: 66%;
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;
